<template>
  <v-container grid-list-md text-xs-center>
    <v-layout >
      <v-flex>
        <v-select v-model="adr1" id="adr1" label="都道府県" :items="adr1_list" item-text="text"
                  item-value="value"></v-select>
      </v-flex>
      <v-flex>
        <v-select v-model="adr2" id="adr2" label="市町村" :items="adr2_list"></v-select>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AddressesFilter',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({adr1: '', adr2: ''})
    },
    addresses: {
      type: Array,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      adr1: this.value.adr1,
      adr2: this.value.adr2
    }
  },
  watch: {
    adr1: function () {
      this.adr2 = ''
      this.$emit('input', {adr1: this.adr1, adr2: this.adr2})
    },
    adr2: function () {
      this.$emit('input', {adr1: this.adr1, adr2: this.adr2})
    }
  },
  computed: {
    adr1_list: function () {
      const a = Array.from(new Set(this.addresses.map(a => ({text: a.adr1, value: a.adr1}))))
      a.unshift({text: 'すべて', value: ''})
      return a
    },
    adr2_list: function () {
      let a
      if (this.adr1) {
        a = Array.from(new Set(this.addresses.filter(a => a.adr1 === this.adr1).map(a => ({
          text: a.adr2,
          value: a.adr2
        }))))
      } else {
        a = Array.from(new Set(this.addresses.map(a => ({text: a.adr2, value: a.adr2}))))
      }
      a.unshift({text: 'すべて', value: ''})
      return a
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AddressesFilter.vue